import { sessionFetch } from './sessionFetch';
import { getServerEndpoint } from './utils';

const API_HEADERS = {
    "x-api-key": "453dabb4-7645-4626-a1bb-477dff3aa557",
    "Content-Type": "application/json"
};

export const uploadImage = async (base64, user, colla) => {
    // Convert the base64 image to an Image object
    const image = new Image();
    image.src = base64;

    await new Promise((resolve) => {
        image.onload = async () => {
            // Get the image dimensions
            const imageWidth = image.width;
            const imageHeight = image.height;
            const minSide = Math.min(imageWidth, imageHeight);

            if (minSide < 200) {
                alert('Si us plau, penja una imatge més gran');
                resolve();
                return;
            }

            // Create a canvas to manipulate the image
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // Set the canvas to the size of the cropped square image
            canvas.width = minSide;
            canvas.height = minSide;

            // Crop the image to a square
            ctx.drawImage(
                image,
                imageWidth / 2 - minSide / 2,
                imageHeight / 2 - minSide / 2,
                minSide,
                minSide,
                0,
                0,
                minSide,
                minSide
            );

            // Create another canvas to resize the image
            const resizedCanvas = document.createElement('canvas');
            resizedCanvas.width = 400;
            resizedCanvas.height = 400;
            const resizedCtx = resizedCanvas.getContext('2d');
            resizedCtx.drawImage(canvas, 0, 0, 400, 400);

            // Convert the canvas back to base64 (JPEG with 0.75 quality)
            const compressedBase64 = resizedCanvas.toDataURL('image/jpeg', 0.75);

            const serverEndpoint = getServerEndpoint(colla);

            await sessionFetch(`${serverEndpoint}/api/profile_pic/${user}`, {
                method: 'POST',
                headers: API_HEADERS,
                body: JSON.stringify({ base64: compressedBase64 })
            });

            resolve();
        };
    });
}

export const downloadImage = async (user, colla) => {
    const serverEndpoint = getServerEndpoint(colla);
    const response = await sessionFetch(`${serverEndpoint}/api/profile_pic/${user}`, {
        headers: { "x-api-key": "453dabb4-7645-4626-a1bb-477dff3aa557" }
    });

    if (!response.ok) return undefined;

    const data = await response.json();
    return data.base64;
}

const uriToBase64 = async (uri) => {
    const response = await sessionFetch(uri);
    const blob = await response.blob();
    return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}